import React, { useState, useEffect } from "react";
import { 
    Form, Input, Button, Row, Col, notification, Select, Table,
    Radio, 
} from "antd";
import { PlusOutlined, InfoCircleOutlined } from '@ant-design/icons';
import {
    getTemplateDNSSetting, deleteTemplateDNSSetting, putTemplateDNSSetting
} from "../../../axios/api.device"

import { useTranslation } from "react-i18next";
import TextArea from "antd/lib/input/TextArea";

const { Item } = Form;
interface propsModel {
    templateId: string,
    platform: string,
    templateTab: any,
    updateTemplate: () => void,
}

export const TemplateContentDNSSetting = (props: propsModel) => {
    const { templateId, platform, templateTab, updateTemplate } = props;
    const [showTable, setShowTable] = useState<number>(0);
    const [dnsProtocol, setDnsProtocol] = useState<string>("HTTPS");
    const [dataForm] = Form.useForm();
    const [prohibitDisablement, setProhibitDisablement] = useState<boolean>(false);

    const { t } = useTranslation();

    var addClick = () => { setShowTable(2) }

    useEffect(() => { getDataInfo() }, [])

    const getDataInfo = () => {
        getTemplateDNSSetting(templateId).then((res) => {
            if (res.dnsProtocol) {
                setShowTable(2);
                setDnsProtocol(res.dnsProtocol);
                setProhibitDisablement(res.prohibitDisablement);
                dataForm?.setFieldsValue(res);
            } else {
                setShowTable(1)
            }
        })
    }

    const addTemplateClick = () => {
        dataForm?.validateFields().then((res) => {
            console.log(res);
            putTemplateDNSSetting(templateId, res).then(() => {
                updateTemplate();
                notification.success({ message: t("成功") });
                getDataInfo();
            })
        })
    }

    const deleteTemplateClick = () => {
        deleteTemplateDNSSetting(templateId).then(() => {
            updateTemplate();
            notification.success({ message: t("成功") });
            dataForm.resetFields();
            getDataInfo();
            setDnsProtocol("HTTPS");
        })
    }

    return (<>
        <div>
            <Row style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                <Col className="templateTitle">{t("DNS设置")}</Col>
            </Row>
            <Row><div className="dividerStyle"></div></Row>
            <div style={{ margin: "16px 16px 16px 0px" }}>
                {showTable == 1 && (
                    <div>
                        <p style={{ margin: "32px 16px 8px 50px", fontSize: "14px" }}>
                            {t("设置DNS")}</p>
                        <div style={{ margin: "32px 16px 8px 50px", fontSize: "16px" }}>
                            <Button onClick={() => { addClick(); }} type="primary">
                                <PlusOutlined /> {t("添加规则")}
                            </Button>
                        </div>
                    </div>
                )}
                {showTable == 2 && (
                    <div style={{ marginLeft: 45 }}>
                        <Form
                            style={{ width: "70%", marginTop: 16 }}
                            layout="vertical"
                            form={dataForm}
                            // labelCol={{ span: 20 }}
                            initialValues={{ dnsProtocol: "HTTPS",
                                prohibitDisablement: prohibitDisablement
                            }}
                        >
                            <Item label={t("DNS Protocol")} name="dnsProtocol" rules={[{ required: true }]}>
                                <Select onChange={(key: string) => {
                                    setDnsProtocol(key);
                                }}>
                                    <Select.Option value="HTTPS">{t("HTTPS")}</Select.Option>
                                    <Select.Option value="TLS">{t("TLS")}</Select.Option>
                                </Select>
                            </Item>

                            <Item 
                                label={t("Server URL")} 
                                name="serverUrl"
                                rules={[{ required: dnsProtocol === "HTTPS" }]} 
                                hidden={dnsProtocol !== "HTTPS"}
                            >
                                <Input />
                            </Item>

                            <Item 
                                label={t("Server Name")} 
                                name="serverName" 
                                rules={[{ required: dnsProtocol === "TLS" }]} 
                                hidden={dnsProtocol !== "TLS"}
                            >
                                <Input />
                            </Item>

                            <Item 
                                label={t("Server Addresses")} 
                                name="serverAddresses" 
                                extra={<><InfoCircleOutlined /> {t("An unordered list of DNS server IP address strings. These IP addresses can be a mixture of IPv4 and IPv6 addresses.")}
                                <br/>{t("Multiple addresses are separated by ';'")}</>}
                            >
                                <TextArea rows={4} />
                            </Item>

                            <Item 
                                label={t("Supplemental Domains")} 
                                name="supplementalMatchDomains"
                                extra={<><InfoCircleOutlined />{t("A list of domain strings used to determine which DNS queries use the DNS server. If not set, all domains use the DNS server.")}
                                <br/>{t("A single wildcard * prefx is supported, but is not required.")}
                                <br/>{t("Multiple domains are separated by ';'")}
                                </>}
                            >
                                <TextArea rows={4} />
                            </Item>
                            
                            <Item label={t("Prohibit Disablement")} 
                                name="prohibitDisablement" 
                                rules={[{ required: true }]}
                                extra={<><InfoCircleOutlined /> {t("If true, the system prohibits users from disabling DNS settings. This key is only available on supervised devices.")}</>}
                            >
                                <Radio.Group >
                                    <Radio value={true}>{t("true")}</Radio>
                                    <Radio value={false}>{t("false")}</Radio>
                                </Radio.Group>
                            </Item>
                        </Form>

                        <div style={{ margin: "32px 16px 8px 0px", fontSize: "20px", textAlign: "center", width: "100%" }}>
                            <Button style={{ width: 100 }} type="primary" onClick={() => { addTemplateClick(); }}> {t("保存")} </Button>
                            <Button style={{ width: 100, marginLeft: 20 }} type="primary" ghost onClick={() => { deleteTemplateClick(); }}>{t("删除规则")}</Button>
                        </div>
                    </div>
                )}
            </div>
        </div>

    </>)
};